import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ico_arrow from "@assets/icons/ico_arrow.svg";
import axios from "@fetch/axios";
import { TokenContext } from "@context/TokenContext";
import { useTranslation } from "@hooks/useTranslation";

import 'rsuite/dist/rsuite.min.css';
import RedwardInformation from "@components/RedwardInformation";
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";

const Component = () => {

  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const { translate } = useTranslation();
  const { getToken } = useContext(TokenContext);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const { lang } = useContext(LanguageCurrencyContext);

  useEffect(() => {

    const fetchUsuario = async () => {
      try {

        const storedToken = getToken();

        const response = await axios.get('/users/data?lang=' + lang,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${storedToken}`
            },
          }
        );
        setUser(response.data);
        localStorage.setItem('user_arteonu', JSON.stringify(response.data))
      } catch (error) {
        console.error('Error fetching user get', error);
      }
    };

    fetchUsuario()
  }, [lang]);


  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <>
      <div className="PerfilContent pt-tophead">

        <div className={`CategoryTitle PerfilSection`}>
          <ul className="Breadcrumb">
            <li onClick={() => { navigate('/home') }} style={{ cursor: "pointer" }}>Home</li>
            <li onClick={() => { navigate('/mi-perfil') }} style={{ cursor: "pointer" }}>{translate('view.myprofile.my_profile')}</li>
            <li>{translate('view.myprofile.my_benefits')}</li>
          </ul>
          
        </div>

        <RedwardInformation user={user} ocultar={false} />

        <hr />

      </div>

      <div className="backgray">

        <div className="PerfilContent">

          <div className="title subtitle titlere">{translate('benefits.unlock')} </div>

          <div className="content-accordion">

          {user && user.loyalty.rewards.length > 0 ? (
            user.loyalty.rewards.map((item, index) => (
              <div className="accordion-item" key={index}>
                <div className={`accordion-header ${item.redeem ? 'reward' : ''}`} onClick={() => toggleAccordion(index)} >
                  {item.redeem ? <div className="flag-reward">{translate('benefits.redem')}</div> : ''}
                  <span>{item.title}</span>
                  <span className="accordion-icon"><img src={ico_arrow} alt="" /></span>
                </div>
                <div className={`accordion-content ${activeAccordion === index ? 'active' : ''}`}>
                  <div className="accordion-body">
                    <p>{item.description}</p>
                  </div>
                </div>
              </div>
            ))
          ) : ''}

          </div>

        </div>

      </div>
    </>
  );
};

export default Component;
